<template>
	<table class="table ct--mini">
		<caption>
			<a class="d-none d-sm-block small float-right mt-2 text-underline" :href="cartpage">{{dict['rediger']}}</a>
			<h4>{{dict['indkøbskurv']}}</h4>
		</caption>
		<template v-if="data.products && data.products.length > 0">
			<tbody>
				<tr v-for="product in data.products" :key="product.id">
					<td class="px-0">
						<a :href="product.link">
							<img v-if="product.thumbnail" width="57" height="38" :src="product.thumbnail" :alt="product.name">
						</a>
					</td>
					<td>
						<a :href="product.link">
							{{product.name}}
							<small>({{product.quantityText}})</small>
						</a>
					</td>
					<td class="text-nowrap text-right">
						{{product.lineTotal}}
					</td>
				</tr>
			</tbody>
			<tfoot>
				<tr class="totals" v-if="data.deliveryMethodText">
					<td colspan="3">
						<div class="d-flex">
							<div class="mr-3">{{data.deliveryMethodText}}</div>
							<div class="text-nowrap text-right ml-auto">{{data.deliveryMethodPrice}}</div>
						</div>
					</td>
				</tr>
				<tr class="totals">
					<td colspan="3">
						<div class="d-flex">
							<b class="mr-3">{{ data.priceIncludingVat ? dict['total inkl. moms'] : dict['total ekskl. moms'] }}</b>
							<b class="text-nowrap text-right ml-auto">{{data.totalPriceExcludingGiftcard}}</b>
						</div>
					</td>
				</tr>
				<tr class="totals" v-if="!data.priceIncludingVat">
					<td colspan="3">
						<div class="d-flex">
							<small class="mr-3 text-black-50">{{ dict['total inkl. moms'] }}</small>
							<small class="text-black-50 text-nowrap text-right ml-auto">{{data.totalPriceWithTaxExcludingGiftcard}}</small>
						</div>
					</td>
				</tr>
				<tr class="gc-summary-list" v-for="giftcard in giftCardPrices" :key="giftcard.giftCardID">
					<td colspan="3">
						<div class="d-flex">
							<div class="mr-3">Nr. {{giftcard.id}} på {{giftcard.balance}} kr. (rest {{giftcard.restAmount}} kr.)</div>
							<div class="text-nowrap text-right ml-auto">DKK {{giftcard.usage}}</div>
						</div>
					</td>
				</tr>
				<tr class="totals" v-if="giftCardPrices.length > 0">
					<td colspan="3">
						<div class="d-flex">
							<b class="mr-3">{{ dict['Samlet pris fratrukket gavekort'] }}</b>
							<b class="text-nowrap text-right ml-auto">{{data.totalPrice}}</b>
						</div>
					</td>
				</tr>
			</tfoot>
		</template>
		<tr v-else>
			<td colspan="3" class="text-center p-4">
				<h5>{{dict['kurven er tom']}}</h5>
			</td>
		</tr>
	</table>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
	name: "MiniCartTable",
	props: ["data2", "data", "dict", "cartpage"],
	computed: {
		giftCardPrices() {
			const result = [];
			var totalExcludingGiftcard = this.data.totalPriceExcludingGiftcard;
			totalExcludingGiftcard = totalExcludingGiftcard.replace(",00","").replace(".","").slice(4);
			totalExcludingGiftcard = Number(totalExcludingGiftcard)

			let giftcardNr = 1

			this.data2.giftcards.forEach(giftcard => {
				result.push({
					id: giftcard.giftCardID,
					balance: giftcard.balanceAmount,
					restAmount: giftcard.restAmount,
					usage: giftcard.usage
				})
				giftcardNr++
			});
			return result;				
		}
	}
});
</script>